import { NotificationDto } from "@core/data/dto/notification.dto";
import { Notification } from "@core/domain/models/notification.model";
import { injectable } from "inversify";
import { DateTime } from "luxon";

@injectable()
export class NotificationMapper {
    map(dto: NotificationDto): Notification | null {
        const createdAt = DateTime.fromISO(dto.created_at);
        if (!createdAt.isValid) return null;

        const readAt = dto.read_at ? DateTime.fromISO(dto.read_at) : null;

        return new Notification(
            dto.id,
            dto.type,
            dto.title,
            dto.message,
            dto.url,
            createdAt,
            readAt && readAt.isValid ? readAt : null,
        );
    }
}
